/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_CutInputs */

const en_shortcut_keys_desc_cut = /** @type {(inputs: Shortcut_Keys_Desc_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cut event or selected text`)
};

const fr_shortcut_keys_desc_cut = /** @type {(inputs: Shortcut_Keys_Desc_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couper l'evenement ou le texte selectionne`)
};

const de_shortcut_keys_desc_cut = /** @type {(inputs: Shortcut_Keys_Desc_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis oder ausgewählten Text ausschneiden`)
};

const it_shortcut_keys_desc_cut = /** @type {(inputs: Shortcut_Keys_Desc_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taglia l'evento o il testo selezionato`)
};

const ru_shortcut_keys_desc_cut = /** @type {(inputs: Shortcut_Keys_Desc_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вырезать событие или выделенный текст`)
};

const es_shortcut_keys_desc_cut = /** @type {(inputs: Shortcut_Keys_Desc_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cortar evento o texto seleccionado`)
};

const zh_cn2_shortcut_keys_desc_cut = /** @type {(inputs: Shortcut_Keys_Desc_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`剪切事件或选定文本`)
};

const ja_shortcut_keys_desc_cut = /** @type {(inputs: Shortcut_Keys_Desc_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントまたは選択したテキストを切り取る`)
};

const hi_shortcut_keys_desc_cut = /** @type {(inputs: Shortcut_Keys_Desc_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट या चयनित टेक्स्ट को काटें`)
};

const pt_pt2_shortcut_keys_desc_cut = /** @type {(inputs: Shortcut_Keys_Desc_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recortar evento ou texto selecionado`)
};

/**
* | output |
* | --- |
* | "Cut event or selected text" |
*
* @param {Shortcut_Keys_Desc_CutInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_cut = /** @type {((inputs?: Shortcut_Keys_Desc_CutInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_CutInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_cut(inputs)
	if (locale === "de") return de_shortcut_keys_desc_cut(inputs)
	if (locale === "it") return it_shortcut_keys_desc_cut(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_cut(inputs)
	if (locale === "es") return es_shortcut_keys_desc_cut(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_cut(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_cut(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_cut(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_cut(inputs)
	return en_shortcut_keys_desc_cut(inputs)
});